import { createFileRoute } from '@tanstack/react-router'
import { PageSkeleton } from '@/components/shared/page-skeleton'
import { useSettings } from '@/hooks'
import { SectionCard } from '@/components/shared/section-card'
import { PageHeader } from '@/components/shared/page-header'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

export const Route = createFileRoute('/_app/settings/general')({
  component: GeneralSettingsPage,
})

function GeneralSettingsPage() {
  const { data: settings, isLoading, error } = useSettings()

  if (isLoading) {
    return <PageSkeleton sections={1} />
  }

  if (error) {
    return (
      <div className="p-8 text-destructive text-sm">
        Erro ao carregar configurações: {error.message}
      </div>
    )
  }

  if (!settings) return null

  return (
    <div className="space-y-6">
      <PageHeader size="sm" title="Geral" description="Informações básicas da sua loja." />

      <SectionCard title="Dados da Loja" description="Informações da sua loja">
        <div className="space-y-4">
          <div className="space-y-2">
            <Label>Nome</Label>
            <Input value={settings.name} readOnly />
          </div>
          <div className="space-y-2">
            <Label>Slug</Label>
            <Input value={settings.slug} readOnly />
          </div>
        </div>
      </SectionCard>
    </div>
  )
}
